var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sweet-modal',{ref:"modal",attrs:{"overlay-theme":"dark"}},[(_vm.imgUrl)?_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.imgUrl,"alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }